module.exports = __webpack_public_path__ + "static/media/returnOfJedi.1f168a2b.jpg";